// extracted by mini-css-extract-plugin
export var core = "Button-module--core--377a5";